import React, { useContext, useState } from 'react'

const IdContext = React.createContext()

export function useId() {
  return useContext(IdContext)
}

// eslint-disable-next-line react/prop-types
export default function IdProvider({ children }) {
  const [sessionId, setSessionId] = useState(undefined)
  const [boardId, setBoardId] = useState(undefined)
  return (
    <IdContext.Provider
      value={{ sessionId, setSessionId, boardId, setBoardId }}
    >
      {children}
    </IdContext.Provider>
  )
}
